import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "bg-[#2c3b4b4f] p-2 px-8 rounded inline-flex py-2.5 px-3 text-center relative" }
const _hoisted_5 = { class: "text-sm font-medium text-white" }
const _hoisted_6 = { class: "text-sm text-white" }
const _hoisted_7 = { class: "text-sm text-white" }
const _hoisted_8 = { class: "text-sm text-white" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "bg-purple-500/10 py-1.5 px-3 rounded inline-flex items-center justify-between gap-2 relative min-w-16" }
const _hoisted_11 = { class: "text-sm font-medium text-white" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "bg-amber-500/10 py-1.5 px-3 rounded inline-flex items-center justify-between gap-2 relative min-w-16" }
const _hoisted_14 = { class: "text-sm font-medium text-white" }
const _hoisted_15 = { class: "flex flex-col gap-1.5" }
const _hoisted_16 = { class: "w-full h-1.5 bg-gray-700/50 rounded-full overflow-hidden" }
const _hoisted_17 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "bg-[#2c3b4b4f] p-1 px-3 rounded inline-flex text-center relative" }
const _hoisted_22 = { class: "text-white font-bold text-lg" }
const _hoisted_23 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_24 = { class: "flex items-center justify-between pt-2 mt-2 border-t border-white/5" }
const _hoisted_25 = { class: "flex flex-col w-full" }
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = { class: "text-xl font-bold text-emerald-400" }
const _hoisted_28 = { class: "w-full h-1.5 bg-gray-700/50 rounded-full overflow-hidden flex-1 max-w-[100px]" }
const _hoisted_29 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}

import { ref, onMounted, watch } from 'vue'
import {
  ArrowsUpDownIcon,
  KeyIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import { Input } from '@/components/ui/input'
import { 
  ArrowUpRight, 
  Search, 
  ArrowUpRight as ArrowUp,
  ArrowDownRight,
  CreditCard, 
} from 'lucide-vue-next'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { useToast } from '@/components/ui/toast'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useLeadStartParameters } from '@/composables/useLeadStartParameters'
import { LeadStartParameter } from '@/interfaces/leads/LeadStartParam'

interface GetAllKeywordsParams {
  page?: string
  perPage?: string
}

// Table Configuration

export default /*@__PURE__*/_defineComponent({
  __name: 'LeadStartParametersView',
  setup(__props) {

const tableHeaders = [
  { key: 'keyword', label: 'Palavra-chave', sortable: false },
  { key: 'totalLeads', label: 'Total de Leads', sortable: true },
  { key: 'buyers', label: 'Vendas', sortable: true },
  { key: 'abandonedCheckouts', label: 'Pix abandonados', sortable: true },
  { key: 'upsellers', label: 'Upsells', sortable: true },
  { key: 'downsellers', label: 'Downsells', sortable: true },
  { key: 'conversionRate', label: 'Taxa de Conversão', sortable: true },
]

// State
const keywords = ref<IPagination<LeadStartParameter>>()
const { toast } = useToast()

// Dialog and Form
const { getAll } = useLeadStartParameters()
const perPage = ref('10')
const searchTerm = ref('')

const sortBy = (key: string) => {
  // Implement sorting logic
  // This would typically sort the keywords.value.data array based on the key
}

const reloadAndGetAll = async (params: GetAllKeywordsParams) => {
  keywords.value = await getAll()
}

const getConversionColor = (rate: number) => {
  if (rate >= 20) return 'emerald';
  if (rate >= 10) return 'amber';
  return 'red';
};

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

onMounted(async () => {
  keywords.value = await getAll()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(PageTitle, null, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Rastreamento de Palavras-chave ")
          ])),
          _: 1
        }),
        _createVNode(PageDescription, null, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Monitore o desempenho das suas palavras-chave e otimize suas campanhas. ")
          ])),
          _: 1
        })
      ])
    ]),
    _createVNode(TableContainer, null, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
          _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Palavras-chave registradas"),
          _createElementVNode("div", { class: "flex items-center gap-4" })
        ], -1)),
        _createVNode(Table, { class: "hidden md:block" }, {
          default: _withCtx(() => [
            _createVNode(TableHeader, null, {
              default: _withCtx(() => [
                _createVNode(TableRow, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                      return _createVNode(TableHead, {
                        key: header.key
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createTextVNode(_toDisplayString(header.label) + " ", 1),
                            (header.sortable)
                              ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                  key: 0,
                                  class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                  onClick: ($event: any) => (sortBy(header.key))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TableBody, null, {
              default: _withCtx(() => [
                (keywords.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (keywords.value.data.length === 0)
                        ? (_openBlock(), _createBlock(TableFallback, {
                            key: 0,
                            colspan: tableHeaders.length,
                            icon: _unref(KeyIcon),
                            title: "Nenhuma palavra-chave encontrada",
                            description: `Você deve adicionar a sua palavra-chave após ?start= no link do seu bot para começar`
                          }, null, 8, ["colspan", "icon"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keywords.value.data, (keyword) => {
                        return (_openBlock(), _createBlock(TableRow, {
                          key: keyword.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(keyword.content), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(keyword.leadsCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(keyword.paidOrdersCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, _toDisplayString((keyword.ordersCount ?? 0) - (keyword.paidOrdersCount ?? 0)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(keyword.upsellCount || 0), 1),
                                    _createVNode(_unref(ArrowUpRight), { class: "size-3 text-purple-400" })
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(keyword.downsellCount || 0), 1),
                                    _createVNode(_unref(ArrowDownRight), { class: "size-3 text-amber-400" })
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["py-1.5 px-3 rounded inline-flex items-center justify-between gap-2 relative min-w-16", ['bg-emerald-500/20']])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["text-sm font-medium", ['text-emerald-300']])
                                    }, _toDisplayString(keyword.leadsCount && keyword.paidOrdersCount
                          ? ((keyword.paidOrdersCount / keyword.leadsCount) * 100).toFixed(1) + '%'
                          : '0%'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["h-full rounded-full transition-all duration-500 ease-out", `bg-emerald-600`]),
                                      style: _normalizeStyle(`width: ${keyword.leadsCount && keyword.paidOrdersCount ? (keyword.paidOrdersCount / keyword.leadsCount) * 100 : 0}%`)
                                    }, null, 4)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createBlock(TableRowSkeleton, {
                      key: 1,
                      columns: tableHeaders.length
                    }, null, 8, ["columns"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (keywords.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (keywords.value.data.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(keywords.value.data, (keyword) => {
                    return (_openBlock(), _createBlock(MobileCard, {
                      key: keyword.id
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Palavra-chave", -1)),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(keyword.content), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(MobileDataLabel, { label: "Total de Leads" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(keyword.leadsCount), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Vendas" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(keyword.paidOrdersCount), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Pix abandonados" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((keyword.ordersCount ?? 0) - (keyword.paidOrdersCount ?? 0)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Upsells" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(keyword.upsellCount || 0), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Downsells" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(keyword.downsellCount || 0), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Taxa de Conversão", -1)),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, _toDisplayString(keyword.leadsCount && keyword.paidOrdersCount ? ((keyword.paidOrdersCount / keyword.leadsCount) * 100).toFixed(1) + '%' : '0%'), 1),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", {
                                  class: "h-full rounded-full bg-emerald-500 transition-all duration-500 ease-out",
                                  style: _normalizeStyle(`width: ${keyword.leadsCount && keyword.paidOrdersCount ? (keyword.paidOrdersCount / keyword.leadsCount) * 100 : 0}%`)
                                }, null, 4)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createVNode(_unref(KeyIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Nenhuma palavra-chave encontrada "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (keywords.value?.pagination)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 1,
              "onUpdate:page": _cache[0] || (_cache[0] = page => reloadAndGetAll({ page, perPage: perPage.value })),
              data: keywords.value?.pagination,
              "per-page": perPage.value,
              "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event))
            }, null, 8, ["data", "per-page"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})